import { AdminRouter } from 'stylemix-vue-admin'

const base = 'vehicle_availability'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.create`,
  path: `/${base}/create`,
  component: () => import('./Create.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.edit`,
  path: `/${base}/:id`,
  component: () => import('./Edit.vue'),
  meta: {
    auth: true,
  },
})
